import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { filterMenuItems } from '../../utils/menuAccess';
import './ParametresPage.css';

const items = [
  { label: 'Banque', icon: '🖥️', path: '/parametres/banque' },
  { label: 'Superviseurs', icon: '👥', path: '/parametres/superviseurs' },
  { label: 'Permissions superviseur', icon: '🔐', path: '/parametres/permissions-superviseur' },
  // Jamais dans menu_keys (hors catalogue backend) : visible uniquement pour le
  // compte principal de la company, cache pour ses utilisateurs / un staff limite.
  { label: 'Utilisateurs', icon: '👤', path: '/parametres/utilisateurs' },
  { label: 'Act/Desactiver Ventes (Manuel)', icon: '🖥️', path: '/parametres/act-desactiver-ventes-manuel' },
  { label: 'Message', icon: '📢', path: '/parametres/message' },
  { label: 'Mes Tirages', icon: '🎯', path: '/parametres/tirages' },
];

const ParametresPage = () => {
  const { company } = useAuth();
  const visibleItems = useMemo(
    () => filterMenuItems(items, company?.menu_keys),
    [company?.menu_keys],
  );

  return (
    <Layout showAvis>
      <p className="param-breadcrumb">
        Ruta: <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <span className="bc-current">Parametres</span>
      </p>

      <div className="param-grid">
        {visibleItems.map((item) => (item.path ? (
          <Link key={item.label} to={item.path} className="param-item">
            <div className="param-icon">{item.icon}</div>
            <span className="param-label">{item.label}</span>
          </Link>
        ) : (
          <div key={item.label} className="param-item">
            <div className="param-icon">{item.icon}</div>
            <span className="param-label param-label-disabled">{item.label}</span>
          </div>
        )))}
      </div>
    </Layout>
  );
};

export default ParametresPage;
